import { render } from "./QuestionDetailHead.vue?vue&type=template&id=05ae25a2&scoped=true&ts=true"
import script from "./QuestionDetailHead.vue?vue&type=script&lang=ts"
export * from "./QuestionDetailHead.vue?vue&type=script&lang=ts"

import "./QuestionDetailHead.vue?vue&type=style&index=0&id=05ae25a2&scoped=true&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ae25a2"]])

export default __exports__